<div id="action-description">
    <div class="d-flex align-items-center mb-0 mx-3 py-3">
        <h6 class="text-color fg-400 p-1 fs-18">{{ 'DASHBOARD.STATISTICS' | translate }}</h6>
        <i class="fa-solid fa-chart-pie me-2 mb-1 fs-18 text-color"></i>
    </div>
</div>
<div class="chart-wrapper d-flex justify-content-center align-items-center p-0 m-auto">
    <ejs-accumulationchart id="donut-container" align="center" [legendSettings]="legendSettings" [tooltip]="tooltip"
        (load)="load($event)" [enableBorderOnMouseMove]="false" (pointRender)="onPointRender($event)">
        <e-accumulation-series-collection>
            <e-accumulation-series name="Revenue" [dataSource]="data" xName="x" [startAngle]="startAngle" yName="y"
                [radius]="radius" [innerRadius]="innerRadius" [dataLabel]="dataLabel" [palettes]="colorPalettes">
            </e-accumulation-series>
        </e-accumulation-series-collection>
    </ejs-accumulationchart>
</div>